import React, { useState } from "react";
import Modal from "@material-tailwind/react/Modal";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import ModalBody from "@material-tailwind/react/ModalBody";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import Button from "@material-tailwind/react/Button";
import Icon from '@material-tailwind/react/Icon';
import Input from '@material-tailwind/react/Input';
import Textarea from '@material-tailwind/react/Textarea';
import axios from "axios";
import { createEvent } from "@testing-library/react";
export default function AddEventForm(props) {
    const [showModal, setShowModal] = useState(false);
    let [name, setName] = useState("")
    let [time, setTime] = useState("")
    let [description, setDescription] = useState("")


    let createEvent = async(e) => {
        let eventObject = {
            name: name,
            time: time,
            description: description,
            daysFree: []
        }
        try {
            let eventCreateRequest = await axios.post(process.env.REACT_APP_API + "/events", eventObject);
        }catch(err) {
            console.log(err)
        } finally {
            setShowModal(false)
            return window.location.reload(); 
        }
    }
    return (
        <>
            <div className="border border-white-600 p-2 pb-1"
                type="button"
                onClick={(e) => setShowModal(true)}
            >
                        <Icon name="add" size="l" color="white"/>
            </div>

            <Modal size="regular" active={showModal} toggler={() => setShowModal(false)}>
                <ModalHeader toggler={() => setShowModal(false)}>
                    Create Event
                </ModalHeader>
                <ModalBody>
                <form onSubmit={(e) => e.preventDefault()}>
                            <div className="flex gap-8 mt-16">
                                <Input
                                    type="text"
                                    placeholder="Name of the Event"
                                    color="lightBlue"
                                    onChange={(e) => {setName(e.target.value)}}
                                />
                            </div>
                            <div className="flex gap-8 mt-10 mb-12">
                            <Input
                                    type="time"
                                    placeholder="Time"
                                    onChange={(e) => {setTime(e.target.value)}}
                                />
                                </div>

                            <Textarea color="lightBlue" onChange={(e) => {setDescription(e.target.value)}}
                            placeholder="Description" />
                        </form>
                </ModalBody>
                <ModalFooter>
                    <Button 
                        color="red"
                        buttonType="link"
                        onClick={(e) => setShowModal(false)}
                        ripple="dark"
                    >
                        Close
                    </Button>

                    <Button
                        color="green"
                        onClick={(e) => createEvent(e)}
                        ripple="light"
                    >
                        Save Changes
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
}